import React, { useContext } from 'react';
import { Modal, Button, Table } from 'react-bootstrap';
import AppContext from 'context/Context';
import { utc2tz } from 'function/convert';

/**
 * @description 월말보고서 이력 Modal
 */

function HistoryModal(props) {
  const {
    config: { isDark }
  } = useContext(AppContext);

  /* props */
  const { modalShow, setModalShow, historyList } = props || {};

  return (
    <Modal
      show={modalShow}
      onHide={() => setModalShow(false)}
      backdrop="static"
      size="lg"
      centered
    >
      <Modal.Header
        closeButton
        closeVariant={isDark ? 'white' : undefined}
        className="px-card border-bottom-0"
      >
        <Modal.Title>이력</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="fs--1">비고내용 등록 HISTORY</p>
        <div className="scrollbar" style={{ maxHeight: '316px' }}>
          <Table responsive bordered className="fs--1 text-center mb-0">
            <thead className="bg-200 text-700 align-middle border-300">
              <tr>
                <th className="text-nowrap">비고 내용 등록일</th>
                <th className="text-nowrap">등록자</th>
                <th className="text-nowrap">등록내용</th>
              </tr>
            </thead>
            <tbody>
              {historyList?.map(({ regDt, regUsrNm, comments }, index) => (
                <tr key={index}>
                  <td>{utc2tz(regDt, 'YYYY-MM-DD HH:mm:ss') || '-'}</td>
                  <td>{regUsrNm || '-'}</td>
                  <td className="text-start">{comments}</td>
                </tr>
              ))}
              {historyList.length < 1 && (
                <tr>
                  <td colSpan={3} className="w-auto">
                    이력이 존재하지 않습니다.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Modal.Body>
      <Modal.Footer className="px-card border-top-0 align-items-center justify-content-center">
        <Button onClick={() => setModalShow(false)}>확인</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default HistoryModal;
